import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@shared/hooks/use-toast';
import { Link } from 'react-router-dom';

const ResetPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const { resetPassword, operationLoading } = useAuth();
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await resetPassword(email);
      toast({ title: 'Email sent', description: 'Check your inbox for reset instructions' });
    } catch (err: any) {
      toast({ title: 'Reset failed', description: err?.message || 'Unable to send reset email', variant: 'destructive' });
    }
  };

  return (
    <div className="flex items-center justify-center bg-background py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h1 className="text-3xl font-bold text-center text-primary">Motiv</h1>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-foreground">Reset password</h2>
          <p className="mt-2 text-center text-sm text-muted-foreground">
            Enter your account email and we will send you a reset link
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-foreground">Email address</label>
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              required
              className="input mt-1 w-full"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={operationLoading}
            />
          </div>

          <div className="space-y-3">
            <button type="submit" className="btn btn-primary w-full" disabled={operationLoading}>
              {operationLoading ? 'Sending...' : 'Send reset email'}
            </button>
            <div className="text-center text-sm">
              <Link to="/login" className="text-primary hover:opacity-80">Back to login</Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;


